import { Money } from 'shared/types/product';

export const isPriceGreaterThanOrEqual = (uvpPrice: Money | undefined, salesPrice: Money | undefined): boolean => {
  return (
    (uvpPrice?.centAmount ?? 0) >= (salesPrice?.centAmount ?? 0) && uvpPrice?.centAmount !== salesPrice?.centAmount
  );
};
